import { CurrencyEnum } from '../../domain/models';

export class SubmitOfferEvent {
  aircraftId: number;
  offerPrice?: number;
  quoteReferenceId?: string;
  ownerAircraftApprovalAcquired?: boolean;
  currency?: CurrencyEnum;
}
